import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { FC } from 'react';

import { IButton } from '../../../types/basket';

import styles from './AddButton.module.sass';

const AddButton: FC<IButton> = ({ ...rest }) => {
  return (
    <div {...rest} className={styles.button}>
      <AddRoundedIcon />
      <div className={styles.text}>Добавить организацию</div>
    </div>
  );
};

export default AddButton;
